import isBoolean from './is-boolean';

const isNumeric = (value) => !Number.isNaN(Number(value)) && !isBoolean(value);

export default isNumeric;
